import { Grid } from '@material-ui/core';
import React, { useState, useEffect } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';

function ReactInfiniteScroll({ size, data, renderItem, height }) {
  const [length, setLength] = useState(size);

  const hasMore = length < data.length;

  useEffect(() => {
    setLength(size);
  }, [size]);

  const handleNext = () => {
    if (hasMore) {
      setLength((prevLength) => prevLength + size);
    }
  };

  return (
    <InfiniteScroll
      dataLength={length}
      next={handleNext}
      hasMore={hasMore}
      height={height}
      loader={<h5>Loading...</h5>}
    >
      <Grid container>{data.slice(0, length).map((item) => renderItem(item))}</Grid>
    </InfiniteScroll>
  );
}

export default ReactInfiniteScroll;
